{
  "home": {
    "title": "Ton espace de jeu",
    "welcome": "Salut, {{name}}.",
    "intro": "Tes récompenses et tes objectifs du jour, au même endroit.",
    "harvest": "Voir la moisson et le classement",
    "play": {
      "title": "Ta prochaine découverte",
      "choose": "Choisir mon booster",
      "available_one": "{{count}} booster gratuit disponible",
      "available_other": "{{count}} boosters gratuits disponibles",
      "next": "Prochain booster gratuit dans {{time}}",
      "empty": "Ta réserve gratuite se recharge.",
      "unavailable": "Réserve indisponible. Consulte la page des boosters pour réessayer."
    },
    "bannerAlt": "Moisson d’Anima : ouvre des boosters, la cagnotte est partagée à la fin du mois",
    "lastDraw": "{{name}}, {{rarity}}",
    "stats": {
      "title": "Le monde ANIDEX",
      "unavailable": "Les statistiques du monde sont momentanément indisponibles.",
      "onlinePlayers": "En ligne",
      "registeredPlayers": "Joueurs",
      "cardsInCirculation": "Cartes",
      "animesInCirculation": "Œuvres",
      "mythicCardsInCirculation": "Mythiques",
      "divineCardsInCirculation": "Divines"
    },
    "login": {
      "combo": "{{count}} jours de suite",
      "unavailable": "Calendrier indisponible. Réessaie depuis sa page.",
      "title": "Connexion du jour",
      "ready": "Récompense prête",
      "streak": "Combo {{streak}} · nouveau jour dans {{time}}",
      "waiting": "Ta récompense quotidienne t’attend sur le calendrier.",
      "month": "Mois {{month}} : +{{chance}} % de chance pour le mois prochain si le combo tient.",
      "open": "Ouvrir le calendrier"
    },
    "quests": {
      "progress": "Voir ta progression",
      "unavailable": "Succès indisponibles. Réessaie depuis leur page.",
      "title": "Quêtes du jour",
      "claimable_one": "{{count}} à réclamer",
      "claimable_other": "{{count}} à réclamer",
      "resets": "Nouvelles dans {{time}}",
      "weeklyTitle": "Quêtes de la semaine",
      "monthlyTitle": "Quêtes du mois",
      "ends": "Fin dans {{time}}",
      "achievements": "Succès"
    },
    "collection": {
      "title": "Ta collection",
      "open": "Ouvrir le classeur",
      "characters_one": "{{formatted}} personnage",
      "characters_other": "{{formatted}} personnages",
      "fragments_one": "{{formatted}} fragment en réserve",
      "fragments_other": "{{formatted}} fragments en réserve",
      "animes_one": "{{formatted}} œuvre complétée.",
      "animes_other": "{{formatted}} œuvres complétées."
    },
    "pity": {
      "orBetter": "{{rarity}} ou mieux",
      "next": "garanti à la prochaine ouverture",
      "within_one": "garanti au plus tard dans {{count}} ouverture",
      "within_other": "garanti au plus tard dans {{count}} ouvertures",
      "of": "du {{name}}."
    }
  },
  "landing": {
    "title": "Tes personnages. Ton histoire.",
    "intro": "Un album pour tes personnages préférés. Ouvre des boosters, fais évoluer tes cartes et complète les œuvres que tu aimes.",
    "start": "Commencer ma collection",
    "free": "Jeu gratuit. L’Anima est une monnaie de jeu.",
    "nextDraw": "Chaque booster ouvre une nouvelle histoire.",
    "experience": "Ton expérience ANIDEX",
    "album": "Un album vivant, de l’anime au jeu vidéo.",
    "community": "Des rencontres, des échanges et des découvertes.",
    "invite": "La première page de ton album t’attend.",
    "seeRules": "Voir les règles",
    "raritiesTitle": "Sept raretés, fixées par la popularité",
    "howTitle": "Comment ça marche",
    "openTitle": "Ouvre des boosters",
    "openText": "Dépense ton Anima pour révéler des personnages. Des garanties évitent les longues séries sans {{rare}}.",
    "duplicatesTitle": "Transforme tes doublons",
    "duplicatesText": "Chaque doublon devient des fragments propres au personnage, de 5 pour un {{common}} à 200 pour une {{divine}}.",
    "upgradeTitle": "Fais évoluer tes cartes",
    "upgradeText": "Les fragments débloquent reflets, cadres et animations jusqu’à l’apparence éveillée."
  },
  "auth": {
    "createAccount": "Créer un compte",
    "password": "Mot de passe",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "login": {
      "title": "Connexion",
      "intro": "Retrouve ta collection et tes quêtes du jour.",
      "noAccount": "Pas encore de compte ?",
      "identifier": "Email ou pseudo",
      "pending": "Connexion…"
    },
    "register": {
      "intro": "Ton aventure commence avec {{anima}} Anima pour ouvrir tes premiers boosters.",
      "haveAccount": "Déjà inscrit ?",
      "email": "Adresse email",
      "username": "Pseudo",
      "usernameHint": "Visible par les autres joueurs. Lettres, chiffres, point, tiret, underscore.",
      "passwordHint_one": "{{count}} caractère minimum, avec au moins un chiffre ou un symbole.",
      "passwordHint_other": "{{count}} caractères minimum, avec au moins un chiffre ou un symbole.",
      "terms": "J’accepte les <terms>conditions d’utilisation</terms>. La <privacy>politique de confidentialité</privacy> décrit les données du compte.",
      "pending": "Création…",
      "submit": "Créer mon compte",
      "referralCode": "Code de parrainage (facultatif)",
      "referralHint": "Ton bonus de {{anima}} Anima et {{boosters}} boosters Premium arrive dès que ton email est vérifié."
    }
  },
  "verify": {
    "title": "Vérification de l’email",
    "missing": "Lien incomplet : ouvre le lien reçu par email.",
    "pending": "Vérification en cours",
    "success": "Adresse confirmée. Tes boosters t’attendent.",
    "home": "Aller à l’accueil",
    "referralSuccess": "Bonus de parrainage reçu : {{anima}} Anima et {{boosters}} boosters Premium !"
  },
  "public": {
    "copyLink": "Copier le lien",
    "anime": {
      "manga": "Manga",
      "anime": "Anime",
      "novel": "Roman",
      "videoGame": "Jeu vidéo",
      "cinematography": "Cinématographie",
      "work": "Œuvre",
      "lead_one": "{{type}} rang {{rank}} - {{formatted}} personnage à collectionner sur ANIDEX.",
      "lead_other": "{{type}} rang {{rank}} - {{formatted}} personnages à collectionner sur ANIDEX.",
      "leadYear_one": "{{type}} rang {{rank}}, {{year}} - {{formatted}} personnage à collectionner sur ANIDEX.",
      "leadYear_other": "{{type}} rang {{rank}}, {{year}} - {{formatted}} personnages à collectionner sur ANIDEX.",
      "englishTitle": "Titre anglais",
      "nativeTitle": "Titre natif",
      "favourites": "Favoris",
      "characters": "Personnages",
      "format": "Format",
      "featured": "Personnages phares",
      "open": "Ouvrir la série",
      "collect": "Collectionner cette série"
    },
    "character": {
      "lead": "Carte {{rarity}} sur ANIDEX.",
      "leadSeries": "Carte {{rarity}} de {{title}} sur ANIDEX.",
      "nativeName": "Nom natif",
      "rarity": "Rareté",
      "favourites": "Favoris AniList",
      "value": "Valeur de référence",
      "role": "Rôle",
      "series": "Série",
      "view": "Voir dans ma collection",
      "collect": "Collectionner ce personnage"
    }
  },
  "rules": {
    "title": "Règles du jeu",
    "intro": "Toutes les valeurs ci-dessous viennent du serveur et s’appliquent telles quelles. Chaque nouveau joueur reçoit",
    "index": "Sections des règles",
    "andUp": "{{formatted}} et +",
    "nav": {
      "boosters": "Boosters",
      "pity": "Pitié",
      "rarity": "Raretés",
      "upgrade": "Améliorations",
      "rank": "Rangs",
      "level": "Niveaux",
      "market": "Marché"
    },
    "boosters": {
      "title": "Boosters et probabilités",
      "duplicate": "Chaque carte a {{percent}} % de chances de se transformer en un personnage de la même rareté que tu possèdes déjà. Si tu n’en as aucun, tu gardes la carte tirée.",
      "rates": "Taux du {{name}}",
      "free_one": "Réserve de {{count}} booster au niveau 1 (+{{perLevel}} par niveau). Un booster se régénère toutes les {{minutes}} min au niveau 1, pour une recharge complète en 1 h.",
      "free_other": "Réserve de {{count}} boosters au niveau 1 (+{{perLevel}} par niveau). Un booster se régénère toutes les {{minutes}} min au niveau 1, pour une recharge complète en 1 h."
    },
    "pity": {
      "title": "Système de pitié",
      "rule_one": "Après {{count}} ouverture sans {{rarity}}, l’ouverture suivante est garantie {{rarity}} ou mieux.",
      "rule_other": "Après {{count}} ouvertures sans {{rarity}}, l’ouverture suivante est garantie {{rarity}} ou mieux.",
      "note": "Plus le booster coûte cher, plus la garantie arrive tôt. Le booster gratuit attend une fois et demie plus longtemps que le Standard. Les compteurs restent sur le serveur, séparés pour chaque type de booster."
    },
    "rarity": {
      "title": "Raretés et fragments",
      "caption": "La rareté dépend du nombre de favoris du personnage.",
      "rarity": "Rareté",
      "favourites": "Favoris",
      "fragments": "Fragments par doublon"
    },
    "upgrades": {
      "title": "Amélioration des cartes",
      "hint": "10 niveaux, une personnalisation à chaque palier et des FX cumulés. Les statistiques et la valeur de la carte progressent, sans modifier les chances de tirage.",
      "valueHint": "La valeur double jusqu’au niveau 5 (×16), puis gagne 4 fois la valeur de base par niveau, jusqu’à ×36 au niveau 10.",
      "ownershipHint": "Les niveaux et fragments existants sont conservés. Les étiquettes restent libres à tous les niveaux. Le style est personnel et ne suit pas une vente ou un échange.",
      "fromStart": "Dès l’obtention",
      "cost_one": "{{formatted}} fragment cumulé",
      "cost_other": "{{formatted}} fragments cumulés"
    },
    "ranks": {
      "title": "Rangs des œuvres",
      "hint": "Le rang est la moyenne entre les 15 % de personnages les plus favoris et les 15 % les moins favoris : on moyenne chaque groupe, on additionne ces deux moyennes, puis on divise par deux."
    },
    "levels": {
      "title": "Niveaux",
      "body": "Ouvrir des boosters et réussir des quêtes rapporte de l’EXP. Chaque niveau coûte plus cher que le précédent : passer du niveau N au niveau N + 1 demande {{base}} × N + {{quadratic}} × N × (N − 1) EXP (niveau 10 → 11 : {{level10}} EXP, niveau 100 → 101 : {{level100}} EXP). Chaque niveau atteint rapporte"
    },
    "market": {
      "title": "Marché, enchères et échanges",
      "access": "Accès dès le niveau {{level}}.",
      "fee": "Frais de vente : {{percent}} % (arrondis au supérieur), retirés de l’Anima et versés dans la cagnotte mensuelle de la Moisson d’Anima. Prix minimum",
      "freeAdds": "Chaque booster gratuit ouvert ajoute",
      "paidAdds": "à cette cagnotte. Un booster payant y ajoute {{percent}} % de son prix (arrondi au supérieur).",
      "buyback": "Reprise par le système : {{percent}} % de la valeur de la carte, niveau compris. Tu ne choisis pas le prix. {{pot}} % de cette somme (arrondis à l’inférieur) vont dans la cagnotte, le reste t’est versé, et la carte quitte ta collection. Plusieurs cartes, ou toute une rareté, se vendent ensemble depuis Purge. Les favoris ne partent pas.",
      "locked": "Une carte en vente, en enchère ou en échange est verrouillée : elle ne peut pas être améliorée ni proposée ailleurs.",
      "transfer": "Lors d’un transfert, tes fragments restants sont mis de côté et te sont rendus si tu récupères le personnage. Un doublon reçu devient des fragments.",
      "listings_one": "Ventes : jusqu’à {{count}} active, durée {{days}}.",
      "listings_other": "Ventes : jusqu’à {{count}} actives, durée {{days}}.",
      "days_one": "{{count}} jour",
      "days_other": "{{count}} jours",
      "auctions": "Enchères : durées {{hours}} h, anti-sniping {{minutes}} min.",
      "tradesBefore_one": "Échanges : {{count}} carte / côté, jusqu’à",
      "tradesBefore_other": "Échanges : {{count}} cartes / côté, jusqu’à",
      "tradesAfter": "d’un seul côté. Tu choisis qui peut te proposer un échange (public, amis, privé).",
      "abuse": "Les abus (prix extrêmes, échanges répétés, comptes liés) peuvent être signalés automatiquement. Conteste un gel via le support ou un signalement depuis l’historique."
    }
  }
}
